export enum MetricsTimeFrame {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
}
